function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnswer2 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 122 122",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.657,101.205c-23.258,23.914 -61.024,24.963 -84.283,2.342c-23.258,-22.622 -23.258,-60.402 0,-84.316c23.259,-23.913 61.025,-24.963 84.283,-2.341c23.259,22.621 23.259,60.402 0,84.315Z",
    style: {
      fill: "#f2d216"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M121.712,60.853l-4.25,-0c-0.001,15.64 -6.332,29.78 -16.579,40.03c-10.251,10.25 -24.389,16.58 -40.027,16.58c-15.638,-0 -29.776,-6.33 -40.027,-16.58c-10.247,-10.25 -16.578,-24.39 -16.58,-40.03c0.002,-15.635 6.333,-29.773 16.58,-40.023c10.251,-10.248 24.389,-16.579 40.027,-16.58c15.638,0.001 29.776,6.332 40.027,16.58c10.247,10.25 16.578,24.388 16.579,40.023l4.25,-0c-0.001,-33.608 -27.245,-60.852 -60.856,-60.853c-33.611,0.001 -60.855,27.245 -60.856,60.853c0.001,33.61 27.245,60.86 60.856,60.86c33.611,-0 60.855,-27.25 60.856,-60.86Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.403,70.053c-1.956,6.29 -5.873,11.73 -11.037,15.6c-5.166,3.86 -11.561,6.141 -18.51,6.141c-6.949,-0 -13.344,-2.281 -18.51,-6.141c-5.164,-3.87 -9.082,-9.31 -11.038,-15.6c-0.348,-1.12 -1.539,-1.75 -2.66,-1.4c-1.12,0.35 -1.746,1.54 -1.398,2.661c2.229,7.169 6.681,13.349 12.55,17.74c5.868,4.39 13.168,6.989 21.056,6.989c7.888,-0 15.188,-2.599 21.055,-6.989c5.869,-4.391 10.322,-10.571 12.551,-17.74c0.348,-1.121 -0.278,-2.311 -1.398,-2.661c-1.121,-0.35 -2.312,0.28 -2.66,1.4l-0.001,-0Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.87,67.323l-6.021,2.89c-1.059,0.5 -1.506,1.77 -1,2.831c0.507,1.059 1.776,1.51 2.834,1l6.022,-2.881c1.058,-0.51 1.506,-1.78 0.999,-2.84c-0.506,-1.05 -1.775,-1.5 -2.834,-1Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.007,71.163l6.021,2.881c1.059,0.51 2.328,0.059 2.835,-1c0.506,-1.061 0.059,-2.331 -1,-2.831l-6.021,-2.89c-1.059,-0.5 -2.328,-0.05 -2.835,1c-0.506,1.06 -0.059,2.33 1,2.84Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.871,47.973c1.687,2.92 4.859,4.88 8.477,4.88c3.374,-0 6.366,-1.71 8.117,-4.31c0.773,-1.14 0.472,-2.699 -0.672,-3.472c-1.144,-0.772 -2.698,-0.471 -3.471,0.673c-0.869,1.279 -2.315,2.109 -3.974,2.109c-1.776,0.01 -3.315,-0.96 -4.15,-2.391c-0.692,-1.194 -2.222,-1.602 -3.416,-0.91c-1.195,0.693 -1.603,2.222 -0.91,3.421l-0.001,-0Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.514,45.462c-0.835,1.431 -2.374,2.401 -4.15,2.391c-1.659,-0 -3.105,-0.83 -3.974,-2.109c-0.773,-1.145 -2.327,-1.445 -3.471,-0.673c-1.144,0.773 -1.445,2.332 -0.672,3.472c1.751,2.6 4.742,4.31 8.117,4.31c3.618,-0 6.789,-1.96 8.476,-4.88c0.692,-1.199 0.285,-2.729 -0.91,-3.421c-1.194,-0.692 -2.724,-0.284 -3.416,0.91Z",
    style: {
      fill: "#272525",
      fillRule: "nonzero"
    }
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnswer2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/answer-2.b9bbe415f136b146244f5590ffec1d6f.svg";